import { useState, type FormEvent } from "react";

import { api } from "../lib/api.js";
import { Button, Input } from "../components/ui.js";

export function Login({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post("/auth/login", { password });
      onSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Connexion impossible");
    } finally {
      setBusy(false);
    }
  }

  return (
    // Même soustraction d'encoche que la coquille (App.tsx) : le body porte
    // déjà le padding safe-area, une hauteur pleine ferait déborder d'autant
    // en PWA plein écran.
    <div className="flex min-h-[calc(100dvh-env(safe-area-inset-top,0px))] items-center justify-center px-6">
      <form onSubmit={submit} className="flex w-full max-w-xs flex-col gap-4">
        <div>
          <h1 className="text-lg font-semibold">Reply Machine</h1>
          <p className="text-sm text-[var(--color-muted)]">Accès privé.</p>
        </div>

        <Input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Mot de passe"
          autoFocus
          autoComplete="current-password"
        />

        {error && <p className="text-sm text-[var(--color-bad)]">{error}</p>}

        <Button type="submit" variant="primary" disabled={busy || !password} full>
          {busy ? "…" : "Entrer"}
        </Button>
      </form>
    </div>
  );
}
